exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-actions-process .button.is-small[data-v-3fa8465e]{border:none;background:transparent;padding:.25rem;width:25px;height:25px}.dropdown-actions-process .button.is-small[data-v-3fa8465e]:hover{background:#ededed}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3fa8465e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/cultura/components/Process/ActionsProcess.vue
// module id = 1484
// module chunks = 2